import { render, staticRenderFns } from "./TodosList.vue?vue&type=template&id=19ef3f87&scoped=true&"
import script from "./TodosList.vue?vue&type=script&lang=js&"
export * from "./TodosList.vue?vue&type=script&lang=js&"
import style0 from "./TodosList.vue?vue&type=style&index=0&id=19ef3f87&prod&lang=css&"
import style1 from "./TodosList.vue?vue&type=style&index=1&id=19ef3f87&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ef3f87",
  null
  
)

export default component.exports